import React, { useState } from 'react';
import bg from 'assets/img/bg/bg-40.png';
import bgDark from 'assets/img/bg/bg-dark-40.png';
import SearchBox from 'components/common/SearchBox';
import { Col, Row } from 'react-bootstrap';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

function SearchCandidate() {
  const params = useParams();
  const [search, setSearch] = useState(params?.search || '');

  const navigate = useNavigate();

  const handleSearch = () => {
    navigate(`/panel/recruitment/search/${search}`);
  };

  return (
    <div className="mb-9">
      <div
        className="mx-n4 mx-lg-n6 mt-n5 position-relative mb-9"
        style={{ height: '208px' }}
      >
        <div
          className="bg-holder d-dark-none"
          style={{
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover'
          }}
        />
        <div
          className="bg-holder d-light-none"
          style={{
            backgroundImage: `url(${bgDark})`,
            backgroundSize: 'cover'
          }}
        />
        <div className="faq-title-box position-relative bg-body-emphasis border border-translucent p-6 rounded-3 text-center mx-auto">
          <h1>Looking for a candidate?</h1>
          <p className="my-3">Filter by roles and skills</p>
          <SearchBox
            className="w-100"
            placeholder=""
            onChange={e => setSearch(e.target.value)}
            onEnter={handleSearch}
            value={search}
          />
        </div>
      </div>
      <Row className="gx-xl-8 gx-xxl-11">
        <Col xs={12} className="m-0">
          <Row className="gx-xl-8 gx-xxl-11 gy-6">
            <Outlet />
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default SearchCandidate;
